import styled from "styled-components";

export const ThreadHiddenDeem = styled.div`
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${props => props.theme.zDefault};
  display: block;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.grey100};
  opacity: 0.8;
`;
